import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProfileAction } from "../../action";

const fieldClass =
  "w-full px-4 py-2.5 bg-neutral-50 border border-neutral-200 rounded-lg cursor-not-allowed text-neutral-500";

const hasValue = (value) => String(value || "").trim().length > 0;

const ReadField = ({ id, label, value, type = "text" }) => (
  <div>
    <label className="block text-sm font-medium text-neutral-700 mb-1" htmlFor={id}>
      {label}
    </label>
    <input type={type} id={id} name={id} value={value} readOnly className={fieldClass} />
  </div>
);

export default function MyDetailsTab() {
  const auth = useSelector((state) => state?.productData?.users);
  const profile = useSelector((state) => state?.productData?.profile);
  const dispatch = useDispatch();

  const fname = profile?.fname || auth?.user?.fname || "";
  const lname = profile?.lname || auth?.user?.lname || "";
  const email = profile?.email || auth?.user?.email || "";
  const phoneNumber = profile?.phoneNumber || "";
  const address = profile?.address || "";
  const city = profile?.city || "";

  useEffect(() => {
    if (!auth?.user?.email || !auth?.user?._id) return;
    dispatch(ProfileAction({ email: auth.user.email, id: auth.user._id }));
  }, [auth?.user?.email, auth?.user?._id, dispatch]);

  return (
    <div className="w-full">
      <div className="rounded-2xl border border-neutral-200 bg-white p-5 sm:p-6 space-y-5">
        <p className="text-sm text-neutral-500">Të dhënat e llogarisë suaj.</p>

        <div className="space-y-4">
          <ReadField id="name" label="Emri" value={fname} />
          <ReadField id="surname" label="Mbiemri" value={lname} />
          <ReadField id="email" label="Email" value={email} type="email" />
          {hasValue(phoneNumber) && (
            <ReadField id="phoneNumber" label="Telefoni" value={phoneNumber} type="tel" />
          )}
          {hasValue(address) && <ReadField id="address" label="Adresa" value={address} />}
          {hasValue(city) && <ReadField id="city" label="Qyteti" value={city} />}
        </div>
      </div>
    </div>
  );
}
